export default __webpack_public_path__ + "static/project-slide-4-415-700-82aaf99dc92f7fdccb445d3bea663dc9.webp";